import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrSharedModule } from '@next/core-lib/shared';

@NgModule({
  declarations: [
    // add shared components here
  ],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    AgrDialogModule,
    AgrFormModule,
  ],
  exports: [
    AgrSharedModule,
    // add shared modules here
  ],
  providers: [
    // add shared services and guards here
    // ApiService,
  ],
})
export class SharedModule {}
